var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremiumIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5794 10.1022L10.0802 13.7015C9.74852 13.9669 9.27032 13.9404 8.96994 13.64L6.69048 11.3605C6.3901 11.0601 6.36361 10.5819 6.62898 10.2502L10.2283 5.75107C11.8742 3.69373 14.366 2.49609 17.0007 2.49609C17.4611 2.49609 17.8344 2.86935 17.8344 3.32977C17.8344 5.96445 16.6367 8.45628 14.5794 10.1022Z",
    fill: "#FA532E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.666 10.8329V14.4861C13.666 14.8019 13.4876 15.0905 13.2051 15.2317L11.191 16.2388C10.9748 16.3469 10.7224 16.3559 10.4991 16.2634C10.2759 16.1709 10.1037 15.9861 10.0273 15.7568L9.49757 14.1676",
    fill: "#FA532E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16285 10.8329L4.57372 10.3032C4.34445 10.2268 4.15962 10.0546 4.06713 9.83133C3.97465 9.60805 3.98361 9.35562 4.09168 9.13946L5.09877 7.12535C5.23998 6.84293 5.52863 6.6645 5.84438 6.6645H9.49757",
    fill: "#FA532E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.12083 17.1579L2.82812 17.5023L3.17256 15.2096C3.28429 14.4659 3.86815 13.882 4.6119 13.7703C5.14936 13.6895 5.69325 13.8686 6.07756 14.253C6.46186 14.6373 6.64097 15.1811 6.56021 15.7186C6.44846 16.4624 5.86459 17.0462 5.12083 17.1579Z",
    fill: "#FA532E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.666 10.8329V14.4861C13.666 14.8019 13.4876 15.0905 13.2051 15.2317L11.191 16.2388C10.9748 16.3469 10.7224 16.3559 10.4991 16.2634C10.2759 16.1709 10.1037 15.9861 10.0273 15.7568L9.49757 14.1676M6.16285 10.8329L4.57372 10.3032C4.34445 10.2268 4.15962 10.0546 4.06713 9.83133C3.97465 9.60805 3.98361 9.35562 4.09168 9.13946L5.09877 7.12535C5.23998 6.84293 5.52863 6.6645 5.84438 6.6645H9.49757M14.5794 10.1022L10.0802 13.7015C9.74852 13.9669 9.27032 13.9404 8.96994 13.64L6.69048 11.3605C6.3901 11.0601 6.36361 10.5819 6.62898 10.2502L10.2283 5.75107C11.8742 3.69373 14.366 2.49609 17.0007 2.49609C17.4611 2.49609 17.8344 2.86935 17.8344 3.32977C17.8344 5.96445 16.6367 8.45628 14.5794 10.1022ZM5.12083 17.1579L2.82812 17.5023L3.17256 15.2096C3.28429 14.4659 3.86815 13.882 4.6119 13.7703C5.14936 13.6895 5.69325 13.8686 6.07756 14.253C6.46186 14.6373 6.64097 15.1811 6.56021 15.7186C6.44846 16.4624 5.86459 17.0462 5.12083 17.1579Z",
    stroke: "#FA532E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumIcon);
export default __webpack_public_path__ + "static/media/premium-icon.f47c0cde4c3aa0ed81dc3ee26dc22dc6.svg";
export { ForwardRef as ReactComponent };